import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';

import DialogBase from './DialogBase';
import { DialogContent, DialogTitle } from '@mui/material';
import EditProductStock from '../edit/EditProductStock';

class DialogEditProductStock extends React.Component {

  render () {
    const { classes, open, onClose, ...others } = this.props;
    const scrollableTargetId = "dialog-edit-product-stock";
    return (
      <DialogBase
        open={open}
        onClose={onClose}
      >
        <DialogTitle>Stock et disponibilité du produit</DialogTitle>
        <DialogContent classes={{root: classes.dialogContent}} id={scrollableTargetId}>
          <EditProductStock
            scrollableTarget={scrollableTargetId}
            {...others}
          />
        </DialogContent>
      </DialogBase>
    )
  }
}

const styles = theme => ({
  dialogContent: {
    padding: theme.spacing(0),
  },
});

DialogEditProductStock.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

export default withStyles(styles, { withTheme: true })(DialogEditProductStock);
